















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StringFilter extends Vue {
  // Props
  @Prop({ required: true })
  public value!: string;
  @Prop({ default: "" })
  public placeholder!: string;
  @Prop({ default: false })
  public disabled!: boolean;
  @Prop({ default: false })
  public required!: boolean;
  @Prop({ default: true })
  public autofocus!: boolean;
  // Methods
  public onInput = this.$_.debounce($event => {
    this.$emit("input", $event);
  }, 250);
}
